<template>
  <v-card style="width: 75vw; margin: 32px auto">
    <div class="d-flex align-start" style="padding: 24px;">
      <h2 class="mr-auto">System Inventory Type</h2>
    </div>
    <v-row class="d-flex align-center mx-5 mb-3">
      <v-col cols=8>
        <v-text-field v-model="search" label="Search" clearable hide-details></v-text-field>
      </v-col>
      <v-col cols=3>
        <v-btn color="white" @click="triggerCreate()">
          <v-icon medium class="py-2 mr-2">
            mdi-plus
          </v-icon>
          New
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table dense :search="search" ref="inventorytypestable" :headers="headers" :items="tableItems"
      :items-per-page="10" :footer-props="footerProps" class="elevation-1 inventory-types-table">
      <template v-slot:item="{ item }">
        <tr @click="triggerUpdate(item)" class="table-hover"
          :class="{ 'last-selected-row': idOfLastSelectedRow === item.id }">
          <td>{{ item.description }}</td>
          <td>
            <div style="display: flex; align-items: center; justify-content: center; margin-right: 21px">
              <div @click.stop="setInventoryTypeActive(item)" class="data-table-button">
                <div
                  style="display:flex; align-items:center; justify-content: center; min-width: 30px; min-height: 30px; size: 30px;">
                  <v-icon :color="item.isActive ? 'green-lighten-1' : 'grey-darken-1'" size="24px"
                    v-model="item.isActive">{{ item.isActive
                      ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div style="display: flex; align-items: center; justify-content: center;">
              <v-tooltip text="Delete" location="top" :open-delay="tooltipOpenDelayDataTable">
                <template v-slot:activator="{ props }">
                  <div v-bind="props" @click.stop="triggerDelete(item)" class="data-table-button">
                    <v-icon color="grey-darken-1" size="30px">mdi-delete</v-icon>
                  </div>
                </template>
              </v-tooltip>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="800px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{ this.systemInventoryType.id === 0 ? 'New' : 'Edit' }} - System Inventory
            Type</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form onsubmit="return false;" autocomplete="off" v-model="isFormValid" ref="newAndEditForm">
              <v-row>
                <v-col cols="12">
                  <v-text-field ref="description" required :rules="reqRules" v-model="systemInventoryType.description"
                    label="Name"></v-text-field>
                  <!-- This text field prevents default form behavior, where the page is reloaded when pressing enter in a form that has only one text field -->
                  <v-text-field style="display: none;"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile outlined class="mb-3" @click="dialog = false; systemInventoryType = {}"><v-icon small
              class="py-2 mr-1">mdi-close</v-icon>
            Cancel</v-btn>
          <v-btn tile outlined class="mb-3 mr-3" @click="triggerSave()" :disabled="!isFormValid"><v-icon small
              class="py-2 mr-1">mdi-content-save</v-icon> Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>

import { HTTP } from '@/plugins/backendAPI'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      tabeItemsChecked: false,
      dialog: false,
      enableEscClear: true,
      footerProps: { 'items-per-page-options': [10, 100, -1] },
      search: '',
      headers: [
        { title: 'Name', key: 'description' },
        { title: 'Active', key: 'isActive', align: "center", width: 100 },
        { title: '', key: 'action', align: "center", sortable: false, width: 100 },

      ],
      idOfLastSelectedRow: 0,
      systemInventoryType: {},
      tableItems: [],
      reqRules: [
        v => !!v || 'Field is required',
      ],
      isFormValid: false,

      sortHandler: {},
      sortOptions: {
        sortBy: [],
        sortDesc: [],
      },

      tooltipOpenDelayDataTable: 200,
    }
  },
  computed: {
    ...mapGetters([
      'sort',
      'issuperadministrator',
      'workspaceid',
      'loading'
    ]),

  },
  watch: {
    dialog(val) {
      if (val) {
        this.enableEscClear = false
        document.addEventListener('keydown', this.submitOnEnter)
      }
      if (!val) {
        document.removeEventListener('keydown', this.submitOnEnter)
        setTimeout(() => {
          this.enableEscClear = true
        }, 100)
      }
    },
  },
  created() {
    this.getitems();
  },
  mounted() {
    document.addEventListener('keydown', this.clearSearchEsc)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.clearSearchEsc)
  },
  methods: {
    getitems() {
      this.$store.dispatch('setLoading', true)
      HTTP.get('/inventorytype/get/system').then(response => {
        this.tableItems = response.data
      }).catch((e) => {
        if (e.response.status === 400) {
          this.$store.dispatch('showError', `Error when getting system inventory types: ${(e.response.data.message ?? e.response.data)} <br><br>Contact your admin if this issue persists.`)
        } else {
          this.$store.dispatch('showError', `Error when getting system inventory types: System inventory types could not be found. <br><br>Contact your admin if this issue persists.`)
        }
      }).finally(() => {
        this.$store.dispatch('setLoading', false)
      })
    },
    triggerSaveDialog() {
      this.dialog = true
      setTimeout(() => {
        this.$refs.description.focus()
      }, 200)

    },
    setInventoryTypeActive(item) {
      item.isActive = !item.isActive
      this.systemInventoryType = Object.assign({}, item)
      this.$store.dispatch('setLoading', true)
      HTTP.post(`/inventorytype/save/system/${this.systemInventoryType.id}/active`, { isActive: this.systemInventoryType.isActive }).then((
      ) => {
      }).catch(e => {
        if (e.response.status === 400) {
          this.$store.dispatch('showError', `Error when updating active status of system inventory type: ${(e.response.data.message ?? e.response.data)} <br><br>Contact your admin if this issue persists.`)
        } else {
          this.$store.dispatch('showError', `Error when updating active status of system inventory type: System inventory type "${this.systemInventoryType.description}" could not have its active status updated. <br><br>Contact your admin if this issue persists.`)
        }
      }).finally(() => {
        this.$store.dispatch('setLoading', false)
      })
    },
    triggerCreate() {
      this.systemInventoryType = { description: "", id: 0, isActive: false }
      this.triggerSaveDialog()
      this.$refs.newAndEditForm.reset()
    },
    triggerUpdate(dit) {
      this.idOfLastSelectedRow = dit.id
      this.systemInventoryType = Object.assign({}, dit)
      this.triggerSaveDialog()
    },
    triggerDelete(dit) {
      this.systemInventoryType = Object.assign({}, dit)
      this.$root.$ConfirmDialog.open('Deleting system inventory type', `This will remove <strong>"${this.systemInventoryType.description}"</strong> as an option when setting system inventory types in workspace. <br/><br/> <strong>Are you sure?</strong>`, { color: 'red', width: 400 }).then((response) => {
        if (response) {
          this.deleteInventoryType()
        }
      })
    },
    triggerSave() {
      if (this.systemInventoryType.id === 0) {
        this.createInventoryType()
      } else {
        this.updateInventoryType()
      }
    },
    createInventoryType() {
      this.$store.dispatch('setLoading', true)
      HTTP.post('/inventorytype/save/system', this.systemInventoryType).then((response) => {
        this.tableItems.push(response.data)
        this.dialog = false
      }).catch(e => {
        if (e.response.status === 400) {
          this.$store.dispatch('showError', `Error when creating: ${(e.response.data.message ?? e.response.data)} <br><br>Contact your admin if this issue persists.`)
        } else {
          this.$store.dispatch('showError', `Error when creating: System inventory type "${this.systemInventoryType.description}" could not be created. <br><br>Contact your admin if this issue persists.`)
        }
      }).finally(() => {
        this.$store.dispatch('setLoading', false)
      })
    },
    deleteInventoryType() {
      this.$store.dispatch('setLoading', true)
      HTTP.post(`/inventorytype/delete/system/${this.systemInventoryType.id}`).then(() => {
        var tableIndex = this.tableItems.findIndex(item => item.id === this.systemInventoryType.id)
        this.tableItems.splice(tableIndex, 1)
      }).catch(e => {
        if (e.response.status === 400) {
          this.$store.dispatch('showError', `Error when deleting system inventory type: ${(e.response.data.message ?? e.response.data)} <br><br>Contact your admin if this issue persists.`)
        } else {
          this.$store.dispatch('showError', `Error when deleting system inventory type: System inventory type "${this.systemInventoryType.description}" could not be deleting. <br><br>Contact your admin if this issue persists.`)
        }
      }).finally(() => {
        this.$store.dispatch('setLoading', false)
      })
    },
    updateInventoryType() {
      this.$store.dispatch('setLoading', true)
      HTTP.post('/inventorytype/save/system', this.systemInventoryType).then((response) => {
        var tableIndex = this.tableItems.findIndex(item => item.id === this.systemInventoryType.id)
        this.tableItems[tableIndex].description = response.data.description;
        this.dialog = false
      }).catch(e => {
        if (e.response.status === 400) {
          this.$store.dispatch('showError', `Error when editing system inventory type: ${(e.response.data.message ?? e.response.data)} <br><br>Contact your admin if this issue persists.`)
        } else {
          this.$store.dispatch('showError', `Error when editing system inventory type: System inventory type "${this.systemInventoryType.description}" could not be edited. <br><br>Contact your admin if this issue persists.`)
        }
      }).finally(() => {
        this.$store.dispatch('setLoading', false)
      })
    },
    submitOnEnter(e) {
      if (e.keyCode == 13 && this.$refs.description.$refs.input == document.activeElement) {
        this.triggerSave()
      }
    },
    clearSearchEsc(e) {
      if (e.keyCode === 27 && this.enableEscClear) {
        this.search = ''
      }
    },
  }
}
</script>
